import { Component } from '@angular/core';

@Component({
  selector: 'app-cards3-examples-18',
  templateUrl: './cards3-examples-18.component.html'
})
export class Cards3Examples18Component {}
